import styled from "styled-components";
import { Table } from "antd";

// Keep header icons (sorter and filter) right next to the column title instead
// of pushed to the far edge of the cell, with the same visible gap everywhere.
// Centralised here so every SbTable shares it (Talent Mobility, Org Design and
// Org Hierarchy carry older module-local copies of the same alignment rule).
//
// !important: AntD's CSS-in-JS injects justify-content: space-between on both
// containers at the same specificity, so without it the winner depends on
// <style> injection order (see TalentMobilityV2/sharedTable.styles.js).
//
// Visible gap is 8px for both icons: the filter trigger is a padded hover
// target (AntD: 4px inline padding), so it gets 4px margin; the sorter has no
// padding, so it gets the full 8px.
//
// Opt-in centering: a column's onHeaderCell className "tm-col-header-center"
// centers its title + icons (used by Talent Mobility score columns).
export const SbTableStyled = styled(Table)`
  .ant-table-filter-column,
  .ant-table-column-sorters {
    justify-content: flex-start !important;
  }
  .ant-table-filter-column .ant-table-column-title,
  .ant-table-column-sorters .ant-table-column-title {
    flex: 0 1 auto !important;
  }
  .ant-table-column-sorter {
    margin-inline-start: 8px;
  }
  .ant-table-filter-trigger {
    margin-inline-start: 4px;
  }
  /* The column whose filter dropdown is open (markOpenFilterColumn): only its filter icon is darkened, so it's clear
     which column's filter is open; the header itself keeps its colour */
  .ant-table-thead > tr > th.sb-filter-open .ant-table-filter-trigger {
    background: rgba(0, 0, 0, 0.12);
    color: #1f2433;
  }
  .tm-col-header-center .ant-table-filter-column,
  .tm-col-header-center .ant-table-column-sorters {
    justify-content: center !important;
  }
`;
